var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ios"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M18.3727 9.78598C18.3727 14.3566 14.6674 18.0661 10.0926 18.0661C5.51785 18.0661 1.8125 14.3566 1.8125 9.78598C1.8125 5.21121 5.51785 1.50586 10.0926 1.50586C14.6674 1.50586 18.3727 5.21121 18.3727 9.78598Z",
    fill: "#283544"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ios_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.82038 12.6475H5.72474V8.45121H4.82038V12.6475ZM5.27074 7.90095C5.5504 7.90095 5.77559 7.66342 5.77559 7.36651C5.77559 7.06169 5.5504 6.82812 5.27074 6.82812C4.99471 6.82812 4.76953 7.06169 4.76953 7.36651C4.76953 7.66342 4.99471 7.90095 5.27074 7.90095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88455 6.84C7.35549 6.84 6.39665 7.97616 6.39665 9.79323C6.39665 11.6103 7.35549 12.7425 8.88455 12.7425C10.41 12.7425 11.3688 11.6103 11.3688 9.79323C11.3688 7.97616 10.41 6.84 8.88455 6.84ZM8.88455 7.71093C9.81797 7.71093 10.4136 8.51851 10.4136 9.79323C10.4136 11.064 9.81797 11.8716 8.88455 11.8716C7.9475 11.8716 7.35549 11.064 7.35549 9.79323C7.35549 8.51851 7.9475 7.71093 8.88455 7.71093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9027 11.0402C11.9427 12.0933 12.7344 12.7425 13.9402 12.7425C15.2078 12.7425 16.0068 12.0616 16.0068 10.9769C16.0068 10.1258 15.5565 9.64675 14.4923 9.38152L13.8894 9.23109C13.2465 9.06482 12.9814 8.84313 12.9814 8.46309C12.9814 7.98804 13.3809 7.67134 13.9729 7.67134C14.5722 7.67134 14.9826 7.992 15.0262 8.52643H15.9197C15.8979 7.52091 15.1352 6.84 13.9802 6.84C12.8398 6.84 12.0298 7.52486 12.0298 8.5383C12.0298 9.35381 12.4875 9.86053 13.4536 10.102L14.1327 10.2762C14.7938 10.4464 15.0625 10.6839 15.0625 11.0957C15.0625 11.5707 14.6231 11.9112 13.9911 11.9112C13.3519 11.9112 12.8688 11.5667 12.8107 11.0402H11.9027Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.82ed77406789a00a6f1189d792fe41ef.svg";
export { ForwardRef as ReactComponent };